// ReusableTable.jsx
import React from 'react'
import NoRecordsFound from '@/product/components/atoms/NoRecordsFound'

const URL_REGEX = /(https?:\/\/[^\s]+)/g

const renderTextWithLinks = (text) => {
    if (!text) return '-'
    return String(text)
        .split(/\\n|\n/)
        .flatMap((line, lineIndex, arr) => {
            const parts = line.split(URL_REGEX).map((part, i) => {
                if (i % 2 === 1) {
                    // Odd indices are the captured URL groups from split
                    // Strip trailing literal \n (backslash-n) that may appear in stored data
                    const cleanUrl = part.replace(/\\n$/, '')
                    return (
                        <a
                            key={`${lineIndex}-${i}`}
                            href={cleanUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {cleanUrl}
                        </a>
                    )
                }
                return part
            })
            return lineIndex < arr.length - 1
                ? [...parts, <br key={`br-${lineIndex}`} />]
                : parts
        })
}

const NotesCustomTable = ({ columns, data }) => {
    return (
        <>
            {data?.length > 0 ? (
                <div style={{ overflowX: 'auto' }}>
                    <table className="table">
                        <thead>
                            <tr>
                                {columns.map((col, index) => (
                                    <th
                                        key={index}
                                        style={{
                                            minWidth: col.minWidth || '120px',
                                            width: col.width || 'auto',
                                            textAlign: 'left',
                                        }}
                                    >
                                        {col.header}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {data?.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {columns.map((col, colIndex) => (
                                        <td
                                            key={colIndex}
                                            data-title={col.accessor}
                                            style={{
                                                minWidth:
                                                    col.minWidth || '120px',
                                                width: col.width || 'auto',
                                                textAlign: 'left',
                                            }}
                                        >
                                            {col.accessor === 'notes' ? (
                                                <div
                                                    style={{
                                                        height: '150px',
                                                        overflowY: 'auto',
                                                    }}
                                                >
                                                    <table>
                                                        <tbody>
                                                            {Array.isArray(
                                                                row.notes
                                                            ) ? (
                                                                row.notes.map(
                                                                    (
                                                                        note,
                                                                        index
                                                                    ) => (
                                                                        <tr
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <td
                                                                                style={{
                                                                                    border: 'none',
                                                                                }}
                                                                            >
                                                                                {renderTextWithLinks(
                                                                                    note
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                )
                                                            ) : (
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            border: 'none',
                                                                        }}
                                                                    >
                                                                        {renderTextWithLinks(
                                                                            row.notes
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : col?.render ? (
                                                col.render(row)
                                            ) : (
                                                row[col.accessor] || '-'
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <NoRecordsFound />
            )}
        </>
    )
}

export default NotesCustomTable
